export default __webpack_public_path__ + "static/media/480_dummy2016-raumgestalter01-mobile-de.5f4a624c.png";